import React from 'react';
import './StandaloneHeader.scss';

const StandaloneHeader = (props) => {
    return (<div className="StandaloneHeader">
        {props.children}
    </div>);
};

export default StandaloneHeader;